import React from 'react';
import BrandLogo from './BrandLogo';
import '../public.css';

export default function PublicLayout({ children, isLogin = false }) {
  return (
    <div className="public-page">
      <a className="public-skip-link" href="#main-content">К содержимому</a>
      <header className="public-header">
        <a className="public-brand" href="/" aria-label="Notreen — главная"><BrandLogo /></a>
        <span className="public-header-note">Личное пространство</span>
        <a className="public-nav-link" href={isLogin ? '/' : '/login'}>
          {isLogin ? 'На главную' : 'Войти'} <span aria-hidden="true">↗</span>
        </a>
      </header>
      <main id="main-content" className="public-main">{children}</main>
      <footer className="public-footer">
        <span>© {new Date().getFullYear()} Notreen</span>
        <span>Для своих. С вниманием к деталям.</span>
      </footer>
    </div>
  );
}
